
/*
 * Empeche le changement de page
 * sur la main nav
 */

// Function d'ouverture de la sous navigation
function ouverture (_e) {
	var current_target = $(".main-navigation-sousnav--CMS_lvl1 #"+$(_e.target).attr("id")+" + .main-navigation-sousnav--CMS_lvl3");

	if($(current_target).hasClass("CMS_current")){
		$(current_target).removeClass("CMS_current");
		$(".CMS_current").removeClass("CMS_current");
		currentPageNavElement();
	}else{
		$(".CMS_current").removeClass("CMS_current");
		$(_e.target).addClass("CMS_current");
		$(current_target).addClass("CMS_current");

		if(!$("body").hasClass("interior")){
			setTimeout(function(){
				$(".CMS_current").removeClass("CMS_current");
			}, 8000);
		}else{
			setTimeout(function(){
				$(".CMS_current").removeClass("CMS_current");
				currentPageNavElement();
			}, 8000);
		}
	}
}

function placementSousnav (_onglet) {
	var id = _onglet;
	var li = $("#"+id+" + .main-navigation-sousnav--CMS_lvl3 li");
	var ulWidth = 0;
	for (var i = 0; i < $(li).length; i++) {

		ulWidth += ($(li[i]).width()+parseInt($(li[i]).css("padding-left"))*2);
	};

	$("#"+id).offset().left;

	var target = $("#"+_onglet+" + .main-navigation-sousnav--CMS_lvl3");
	var wmx = 0;
	var wmxdecal = 0;
	if($(window).width()>1170){
		wmx = 1170;
		wmxdecal = ($(window).width() - wmx)/2;
	}else{
		wmx = $(window).width();
		wmxdecal = ($(window).width() - wmx)/2;
	}
	var decalage = ($(window).width()-$("#"+id).offset().left)-ulWidth;

	if(decalage < wmxdecal){
		decalage = wmxdecal;
	}
	$(target).css("padding-right", decalage);
}

$.each($(".main-navigation--link"), function( k, v ) {
	var target = $(".main-navigation--link");

	placementSousnav($(target[k]).attr("id"));
});



$(window).resize(function (){
	$(".main-navigation--link")
	$.each($(".main-navigation--link"), function( k, v ) {
		var target = $(".main-navigation--link");

		placementSousnav($(target[k]).attr("id"));
	});
})

$(window).click(function (_e) {
	// Pour refermer la navigation quand on click sur la page
	if(!$(_e.target).hasClass("main-navigation--link")){
		$(".CMS_current").removeClass("CMS_current");
		currentPageNavElement();
	}
})

// Detection du click sur les onglet
$(".main-navigation--link").click(function (_e) {
	_e.preventDefault();

	ouverture(_e);
})


// // A REFLECHIR
// // Pour passer apres le script de wow js qui la rend
// $($(".navigation-container--logo img")).load(function() {
// 	if($(".container-visuel--logo").length){
// 		if($(".container-visuel--logo").offset().top+$(".container-visuel--logo").height() < $(window).scrollTop()){
// 			$(".navigation-container--logo img").css({
// 				"animation-name": "fadeInDown",
// 				"-webkit-animation-name": "fadeInDown"
// 			});
// 		}
// 	}else{
// 		//$(".navigation-container--logo img").css("display", "none");
// 	}
// });

function activeMobileNavigation () {
	if($(".mobile-navigation").hasClass("active")){
		$(".mobile-navigation").removeClass("active");
	}else{
		$(".mobile-navigation").addClass("active");
	}
	if($(".burger").hasClass("active")){
		$(".burger").removeClass("active");
	}else{
		$(".burger").addClass("active");
	}
	if($("body").hasClass("active-navigation-mobile")){
		$("body").removeClass("active-navigation-mobile");
	}else{
		$("body").addClass("active-navigation-mobile");
	}
}
$(".burger").click(function  () {
	activeMobileNavigation();
})
var elem = document.getElementsByClassName("mobile-navigation");
if(elem.length!=0){
	Hammer(elem[0]).on("swiperight", function(event) {
		activeMobileNavigation();
	})
}


function currentPageNavElement() {
	if(window.location.pathname != "/" && window.location.pathname != "/web/Running_Eiffage/") {
		$("a[href^='"+window.location.href+"']").addClass("CMS_current")
		$("a[href^='"+window.location.href+"']").parent().parent().addClass("CMS_current");

		if ($(".CMS_current").length) {
			var current = $(".CMS_current").parent();
			var idcurrent = $(current).children("a").attr("id")

			$("#"+idcurrent).addClass("CMS_current");
		}
	}
}

currentPageNavElement();


//----nav mobile 
function mobile () {
	$( ".mobile-navigation .main-navigation-sousnav--link.CMS_lvl2" ).click(function(e) {
		e.preventDefault();
		if($(this).next().hasClass('active')){
			$(this).next().removeClass('active');

		}else{
			$(".main-navigation-sousnav--CMS_lvl3").removeClass('active');
			$(this).next().addClass('active');
		}
		$(this).next().hasClass('CMS_current') ? $(this).next().removeClass('CMS_current') : $(this).next().addClass('CMS_current');
	});
}
mobile();

//---- target blank on subnav of INSCRIPTION 
$(".spc-127").attr("target","_blank");
$(".spc-128").attr("target","_blank");
$(".spc-129").attr("target","_blank");